module.exports = __webpack_public_path__ + "static/engi-d440420bcc988388984c6634a7318d50.jpg";